export interface IUserEntity {
    id?: string;
    aliasId?: string;
    name?: string;
    username?: string;
    email?: string;
    kind?: number;
    password?: string;
    systemId?: string;
    ruleGroupId?: string;
    active?: boolean;
    createdAt?: Date;
    createdBy?: string;
    updatedAt?: Date;
    updatedBy?: string;
    phone?: string;
}
